import { ArrowRight, Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { schedulePresets } from "../../lib/schedule-presets/schedule-presets";
import { useScheduleStore } from "../../stores/schedule-store";
import { dispatchScheduleEvent } from "../../lib/schedule-history/dispatch";
import { cn } from "../../lib/utils";

export function PresetSelector() {
  const { t } = useTranslation();
  const selected = useScheduleStore(state => state.preset);

  return (
    <section aria-labelledby="preset-heading" className="space-y-3">
      <h2 id="preset-heading" className="text-xs font-semibold uppercase tracking-wider">{t("preset.title")}</h2>
      <div className="grid grid-cols-[minmax(0,5fr)_minmax(0,7fr)] items-stretch overflow-hidden rounded border border-neutral-200 bg-neutral-50">
        <div className="min-w-0 p-2">
          <p className="relative z-10 inline-flex max-w-full items-center rounded-t border border-neutral-200 bg-neutral-50 px-2 py-1 text-[10px] font-bold leading-snug text-neutral-900 [overflow-wrap:anywhere]">{selected.label}</p>
          <div className="-mt-px overflow-hidden rounded rounded-tl-none border border-neutral-200">
            <img src={selected.base} alt={t("preset.previewAlt", { name: selected.label })} className="aspect-video w-full object-cover" />
          </div>
        </div>
        <div className="min-w-0 border-l border-neutral-200 p-2">
          <div className="flex items-center justify-between gap-2 px-1 pb-1.5 text-[10px] font-semibold uppercase tracking-wider text-neutral-500">
            <span>{t("preset.available")}</span>
            <span>{schedulePresets.length}</span>
          </div>
          <div className="max-h-[125px] space-y-1.5 overflow-y-auto pr-4">
            {schedulePresets.map(preset => (
              <button key={preset.id} type="button" title={preset.label}
                onClick={() => {
                  if (selected.id === preset.id) return;
                  dispatchScheduleEvent({ type: "preset/select", presetId: preset.id });
                }}
                className={cn(
                  "group flex w-full min-w-0 items-center gap-2 rounded border bg-white p-2 text-left transition-colors focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-neutral-900",
                  selected.id === preset.id ? "border-neutral-900 bg-neutral-100" : "border-neutral-200 hover:border-neutral-400 hover:bg-neutral-100",
                )}>
                <img src={preset.base} alt="" className="h-7 w-9 shrink-0 rounded border border-neutral-200 object-cover" />
                <span className="min-w-0 flex-1 truncate text-xs font-medium text-neutral-800">{preset.label}</span>
                {selected.id === preset.id
                  ? <Check className="size-3.5 shrink-0 text-neutral-900" />
                  : <ArrowRight className="size-3.5 shrink-0 text-neutral-400 group-hover:text-neutral-900" />}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
